import { styled } from '@mui/system'
import { Box, Stack, Typography } from '@mui/material'

export const SideContent = styled(Stack)(({ theme }) => ({
  position: 'relative',
  flex: 1,
  gap: theme.spacing(2),
  border: `1px solid ${theme.palette.grey[200]}`,
  borderRadius: theme.spacing(1),
  padding: theme.spacing(1.5, 3, 2),
  backgroundColor: theme.palette.common.white,
}))

export const BlockContent = styled(Box)(({ theme }) => ({
  display: 'flex',
  fontWeight: 400,
  fontSize: 14,
  lineHeight: 1.6,
  color: theme.palette.grey[900],
}))

export const BlockInfo = styled(Box)(({ theme }) => ({
  display: 'flex',
  flex: 1,
  flexDirection: 'column',
  minHeight: theme.spacing(4),
}))

export const BlockTitle = styled(Typography)(({ theme }) => ({
  display: 'flex',
  fontWeight: 700,
  textTransform: 'uppercase',
  fontSize: 10,
  lineHeight: 1.4,
  color: theme.palette.grey[600],
}))

export const CardMainContent = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'column',
  flex: '1',
  // gap: theme.spacing(3),
  fontSize: 14,
}))

export const CardUserInfos = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  gap: theme.spacing(1),
}))

export const Title = styled(Typography)(({ theme }) => ({
  fontWeight: 600,
  fontSize: 10,
  textTransform: 'uppercase',
  lineHeight: 1.3,
  color: theme.palette.grey[600],
}))

export const RoomName = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '22px',
  color: theme.palette.grey[800],
}))

export const RoomCreationDate = styled(Typography)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'center',
  fontWeight: 400,
  fontSize: 13,
  lineHeight: '22px',
  color: theme.palette.grey[800],
}))

export const WifiPSK = styled(Typography)(({ theme }) => ({
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '24px',
  color: theme.palette.grey[800],
}))

export const CodeBox = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  alignItems: 'center',
  padding: '8px 12px',
  gap: '8px',
  borderRadius: '6px',
  background: 'rgba(68, 99, 140, 0.08)',
  fontWeight: 500,
  fontSize: 16,
  lineHeight: '22px',
  color: theme.palette.grey[800],
  cursor: 'pointer',
}))

const Tag = styled(Box)(() => ({
  position: 'relative',
  width: 10,
  height: 10,
  borderRadius: 5,
}))

export const ConnectedTag = styled(Tag)(() => ({
  background: '#92BC62',
}))

export const DisconnectedTag = styled(Tag)(() => ({
  background: '#F15656',
}))

export const NotConfiguredTag = styled(Tag)(() => ({
  background: '#EEA20A',
}))

export const ConnectedStatus = styled(BlockContent)(() => ({
  color: '#92BC62',
}))

export const DisconnectedStatus = styled(BlockContent)(() => ({
  color: '#F15656',
}))

export const NotConfiguredStatus = styled(BlockContent)(() => ({
  color: '#EEA20A',
}))

export const Device = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  padding: theme.spacing(2, 0),
  borderBottom: '1px solid #dce1e5',
  '&:last-child': {
    borderBottom: 'none',
  },
}))

export const DeviceTopBar = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  justifyContent: 'space-between',
  alignItems: 'flex-start',
}))

export const DeviceOtherInfos = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  rowGap: theme.spacing(2),
  columnGap: theme.spacing(3),
}))
